// libs
import React from 'react';
import PropTypes from 'prop-types';

// Components
import Image from '../../../../tools/image/Image';

// Props and Context
const propTypes = {
  mediaUrl: PropTypes.string,
  alt: PropTypes.string,
  description: PropTypes.string,
};

const defaultProps = {
  mediaUrl: '',
  alt: '',
  description: '',
};

const contextTypes = {};

function ImageModal(props) {
  const {
    mediaUrl,
    alt,
    description,
  } = props;
  return (
    <div>
      <Image mediaUrl={mediaUrl} alt={alt} />
      {description &&
      <div className="modal__text" dangerouslySetInnerHTML={{ __html: description }} />
      }
    </div>
  );
}

ImageModal.contextTypes = contextTypes;
ImageModal.propTypes = propTypes;
ImageModal.defaultProps = defaultProps;

export default ImageModal;



// WEBPACK FOOTER //
// ./src/app/components/singles/activity/parts/imageModal/ImageModal.js